import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storageHandler } from "../../Helpers";
import { Toast } from "../../Components";
import CryptoJS from "crypto-js";
import {
  searchProfileService,
  billingService,
  orderService,
} from "../../Services";
import NotSubscribe from "../../Components/Base/Common/NotSubscribe";
import CartInfluencer from "../../Components/Base/Common/CartInfluencer";
import { cartutils } from "../../Helpers";
import { SwitchWithLabel } from "../../Components/AppSwitchWithLabel";
import { Tooltip } from "../../Components/Tooltip";

export default function PlaceOrder({
  user,
  goToPricing,
  NotifModul,
  setModal,
  profiles,
  setModalNotification,
  closeCartPanel,
  setAuth,
  updateProfilePage,
  setUpdateProfilePage,
  setPaypalAmt,
  paypalAmt,
  availableBalance,
  showCart,
  setShowCart,
  cartItem,
  setCartItem,
  setOrderCreated,
}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isloaded, setIsLoaded] = useState(false);
  const [fromAvailableBalance, setFromAvailableBalance] = useState();
  const [toastList, setToastList] = useState([]);
  const [cartItemSaved, setCartItemSaved] = useState([]);
  const [fees, setFees] = useState(0);
  const [isUserHasSubscription, setUserHasSubscription] = useState(false);
  const [subTotalAmt, setSubTotalAmt] = useState(0);
  const [totalToPay, setTotalToPay] = useState(0);
  const [showDetails, setShowDetails] = useState(true);
  const navigate = useNavigate();
  const [payAccount, setPayAccount] = useState("paypal");
  const [orderRef, setOrderRef] = useState("");
  const [feesAmt, setFeesAmt] = useState(process.env.REACT_APP_FEES);
  const secretKey = process.env.REACT_APP_SECRET_KEY;

  const addToast = (data) => {
    const newToastList = [...toastList];
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };

  const encryptData = (data, secretKey) => {
    return CryptoJS.AES.encrypt(data, secretKey).toString();
  };

  const exploreInf = () => {
    navigate("/brand/influencerdiscovery");
  };

  useEffect(() => {
    let ordersuccess =
      searchParams.get("ordersuccess") !== null
        ? searchParams.get("ordersuccess")
        : "";

    const chkUser = async () => {
      if (ordersuccess !== "") {
        setOrderRef(ordersuccess);
        setUserHasSubscription(true);
        setShowDetails(false);
        const storedOption = localStorage.getItem("pendingOrderOption");
        if (storedOption) {
          const decryptedOption = JSON.parse(
            decryptData(storedOption, secretKey)
          );
          decryptedOption.orderRef = ordersuccess;

          try {
            const orderRes = await orderService.createOrder(decryptedOption);
            
            if (orderRes.success === false) {
              addToast({
                error: true,
                msg: orderRes.message,
                id: `${Date.now()}-${toastList.length}`,
              });
              return;
            }
            
            localStorage.removeItem("pendingOrderOption");
            storageHandler.deleteCreditAmt();
            const updatedCartItems = cartutils.getCartafterRemovingItemInArray(
              user.data.id
            );
            let encrypteddata = encryptData(
              JSON.stringify(updatedCartItems),
              secretKey
            );
            storageHandler.setCartItem(encrypteddata);
            setCartItem([]);
            setShowCart(false);
            setOrderCreated(true);
            navigate("/brand/orderDetails/" + orderRes.data.id);
          } catch (err) {
            addToast({
              error: true,
              msg: err.message || err,
              id: `${Date.now()}-${toastList.length}`,
            });
          }
        }
      } else {
        setShowDetails(true);
      }
    };

    chkUser();
  }, [user]);

  async function checkout() {
    try {
      const res = await searchProfileService.getBalance();
      let priceval = res.wallet_details.available;
      let availableWallet = parseFloat(priceval?.replace(/[$,]/g, ""));
      console.log("🚀 Darshana ~ BalanceDetails ~ priceval:", priceval)
      console.log("🚀 Darshana ~ availableWallet ~ availableWallet:", availableWallet)
      try {
        if (user !== null) {
          let getcartItem = cartutils.getCartItemInArray(user.data.id);
          const checkoutDetails = calculateOrderDetails(
            getcartItem,
            availableWallet
          );
          console.log("🚀 Darshana ~ checkoutDetails ~ checkoutDetails:", checkoutDetails)

          let credit = checkoutDetails.creditApplied;
          let decryptedTotalAmtData = storageHandler.getCreditAmt();
          console.log("🚀 Darshana ~ decryptedTotalAmtData ~ decryptedTotalAmtData:", decryptedTotalAmtData)
          if (decryptedTotalAmtData !== null) {
            const creditAmt = decryptData(decryptedTotalAmtData, secretKey);
            console.log("🚀 Darshana ~ creditAmt :", creditAmt)
            // credit = Number(checkoutDetails.subtotalWithFees) - Number(creditAmt);
            // console.log("🚀 Darshana ~ credit :", credit)
          }

          let option = {
            subTotalAmt: checkoutDetails.subtotalVal,
            subtotal: checkoutDetails.subtotalWithFees,
            cartItem: getcartItem,
            fees: checkoutDetails.platformFeesForTama,
            totalFees: checkoutDetails.totalFees,
            credit: credit,
            orderRef: orderRef,
            final_charge: checkoutDetails.finalTotalToPay,
            payment_direct: checkoutDetails.directPaymentTotal,
            payment_via_tama: checkoutDetails.tamaPaymentTotal,
            platform_fee: checkoutDetails.platformFeesForTama,
          };

          try {
            const orderRes = await orderService.createOrder(option);
            console.log("🚀 ~ checkout ~ orderRes:", orderRes)
            
            if (orderRes.success === false) {
              addToast({
                error: true,
                msg: orderRes.message,
                id: `${Date.now()}-${toastList.length}`,
              });
              return;
            }
            
            if (orderRes.message === "paypal") {
              const encryptedOption = encryptData(
                JSON.stringify(option),
                secretKey
              );
              localStorage.setItem("pendingOrderOption", encryptedOption);
              addMoneyForCartFromPaypal();
            } else {
              storageHandler.deleteCreditAmt();
              const updatedCartItems = cartutils.getCartafterRemovingItemInArray(
                user.data.id
              );
              let encrypteddata = encryptData(
                JSON.stringify(updatedCartItems),
                secretKey
              );
              storageHandler.setCartItem(encrypteddata);
              setCartItem([]);
              setShowCart(false);
              setOrderCreated(true);
              navigate("/brand/orderDetails/" + orderRes.data.id);
            }
          } catch (err) {
            addToast({
              error: true,
              msg: err.message || err,
              id: `${Date.now()}-${toastList.length}`,
            });
          }
        }
      } catch (err) {
        addToast({
          error: true,
          msg: err,
          id: `${Date.now()}-${toastList.length}`,
        });
      }
    } catch (err) {
      addToast({
        error: true,
        msg: err,
        id: `${Date.now()}-${toastList.length}`,
        });
    }
  }

  const addMoneyForCartFromPaypal = async () => {
    let option = {};
    let encryptedTotalPay = encryptData(JSON.stringify(totalToPay), secretKey);
    storageHandler.setCreditAmt(encryptedTotalPay);
    const payload = {
      amount: totalToPay,
      description: "Order for amt" + totalToPay,
      account: payAccount,
      type: "offer",
      subTotalAmt: subTotalAmt,
      totalToPay: totalToPay,
      cartItem: cartItem,
    };
    try {
      const res = await billingService.addBalance(payload);
      if (res.url) {
        window.location.replace(res.url);
      }
    } catch (error) {
      addToast({
        error: true,
        msg: error,
        id: `${Date.now()}-${toastList.length}`,
      });
    }
  };

  useEffect(() => {
    setUserHasSubscription(
      user !== null
        ? user.data.isUserHasSubscription === 1
          ? true
          : false
        : false
    );
  }, [user]);

  const calculateOrderDetails = (cartItems, balance = availableBalance) => {
    const directPaymentItems = cartItems.filter(
      (item) => item.tama_payment === 0
    );
    const tamaPaymentItems = cartItems.filter(
      (item) => item.tama_payment === 1
    );
    const directPaymentTotal = directPaymentItems?.reduce(
      (sum, item) => sum + parseFloat(item.price),
      0
    );
    const tamaPaymentTotal = tamaPaymentItems?.reduce(
      (sum, item) => sum + parseFloat(item.price),
      0
    );
    const totalFees = tamaPaymentItems.length * feesAmt;
    const platformFeesForTama = tamaPaymentItems.length * feesAmt;
    const subtotalVal = cartutils.calSubTotal(cartItems);
    const subtotalWithFees = subtotalVal + totalFees;
    const tamaSubtotal = tamaPaymentTotal + platformFeesForTama;

    const creditApplied =
      cartutils?.calDeductionFromavailableBalance(tamaSubtotal, balance) || 0;
    const finalTotalToPay = cartutils.calTotalToPay(
      subtotalWithFees,
      cartutils.calDeductionFromavailableBalance(subtotalWithFees, balance)
    );

    return {
      directPaymentTotal,
      tamaPaymentTotal,
      totalFees,
      platformFeesForTama,
      subtotalVal,
      subtotalWithFees,
      tamaSubtotal,
      creditApplied,
      finalTotalToPay,
    };
  };

  const orderDetails = calculateOrderDetails(cartItemSaved);

  useEffect(() => {
    if (user !== null) {
      let getcartItem = cartutils.getCartItemInArray(user.data.id);
      setCartItemSaved(getcartItem);

      if (availableBalance !== "" && availableBalance !== null) {
        const details = calculateOrderDetails(getcartItem);
        setFromAvailableBalance(details.creditApplied);
        setTotalToPay(details.finalTotalToPay);
        setFees(details.totalFees);
        setSubTotalAmt(details.subtotalVal);
      }
      setIsLoaded(true);
    }
  }, [user, cartItem, availableBalance, cartItemSaved]);

  const decryptData = (cipherText, secretKey) => {
    const bytes = CryptoJS.AES.decrypt(cipherText, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  };

  const handlePaymentToggle = (index, checked) => {
    const updatedCart = [...cartItemSaved];
    updatedCart[index].tama_payment = checked ? 1 : 0;
    setCartItemSaved(updatedCart);

    const encryptedData = encryptData(JSON.stringify(updatedCart), secretKey);
    storageHandler.setCartItem(encryptedData);

    if (availableBalance !== "" && availableBalance !== null) {
      const details = calculateOrderDetails(updatedCart);
      setFromAvailableBalance(details.creditApplied);
      setTotalToPay(details.finalTotalToPay);
      setFees(details.totalFees);
      setSubTotalAmt(details.subtotalVal);
    }
  };

  return (
    <>
      {isUserHasSubscription === true && (
        <>
          <div className="overflow-hidden">
            {isloaded && showDetails && (
              <div className="space-y-4">
                {/* Header */}
                <div className="bg-blue-50 border border-blue-200 rounded-xl p-3 mb-4">
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <svg
                        className="w-5 h-5 text-blue-600 mt-0.5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <p className="ml-3 text-blue-800">
                      If an influencer declines the offer, the amount will be
                      added to your Tama balance.
                    </p>
                  </div>
                </div>

                {cartItemSaved.length > 0 ? (
                  <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-4">
                    {/* Order Summary - Left Column */}
                    <div className="lg:col-span-2 flex">
                      <div className="bg-white rounded-2xl shadow-sm border border-emerald-100 p-3 sm:p-4 flex flex-col w-full">
                        <h2 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3 pb-2 border-b border-emerald-100 flex-shrink-0">
                          Order Summary
                        </h2>
                        {/* Scrollable cart items */}
                        <div
                          className=" flex-1 overflow-y-auto pr-1 sm:pr-2"
                          style={{
                            maxHeight: "calc(100vh - 600px)",
                            minHeight: "400px",
                            scrollbarWidth: "thin",
                            scrollbarColor: "#e5e7eb transparent",
                          }}
                        >
                          {cartItemSaved.map((cartItemLoop, index) => (
                            <div
                              key={index}
                              className="bg-gray-50/50 rounded-xl p-2 sm:p-3 border border-emerald-50"
                            >
                              <CartInfluencer
                                cartItemLoop={cartItemLoop}
                                updateProfilePage={updateProfilePage}
                                setUpdateProfilePage={setUpdateProfilePage}
                              />

                              {/* Tama Payment Toggle */}
                              <div className="mt-2 p-2 sm:p-3 bg-gradient-to-r from-emerald-50 to-teal-50 rounded-lg border border-emerald-200">
                                <div className="flex items-center justify-between gap-2">
                                  <div className="flex items-center space-x-2 sm:space-x-3 flex-1 min-w-0">
                                    <div className="w-8 h-8 sm:w-10 sm:h-10 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                                      <svg
                                        className="w-4 h-4 sm:w-5 sm:h-5 text-emerald-600"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </div>
                                    <div className="min-w-0 flex-1">
                                      <p className="text-xs sm:text-sm font-semibold text-gray-900 truncate">
                                        Use Tama Payment
                                      </p>
                                      <p className="text-xs text-emerald-600 truncate">
                                        Secure payment through Tama platform
                                      </p>
                                    </div>
                                  </div>
                                  <SwitchWithLabel
                                    id={`payment-${index}`}
                                    label=""
                                    labelRight=""
                                    className=""
                                    checked={cartItemLoop.tama_payment === 1}
                                    onCheckedChange={(checked) =>
                                      handlePaymentToggle(index, checked)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    {/* Payment Details - Right Column */}
                    <div className="lg:col-span-1 flex">
                      <div className="bg-white rounded-2xl shadow-sm border border-emerald-100 p-3 sm:p-4 lg:sticky lg:top-4 flex flex-col w-full h-fit lg:h-auto">
                        <h2 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3 pb-2 border-b border-emerald-100 flex-shrink-0">
                          Payment Details
                        </h2>

                        <div className="space-y-6 sm:space-y-6 flex-1">
                          <div className="flex justify-between items-start gap-2">
                            <span className="text-xs sm:text-sm text-gray-600 flex-1">
                              Influencer Payment (Direct)
                            </span>
                            <span className="text-xs sm:text-sm text-gray-900 font-medium">
                              ${orderDetails.directPaymentTotal.toFixed(2)}
                            </span>
                          </div>

                          <div className="flex justify-between items-start gap-2">
                            <span className="text-xs sm:text-sm text-gray-600 flex-1">
                              Influencer Payment via TAMA
                            </span>
                            <span className="text-xs sm:text-sm text-gray-900 font-medium">
                              ${orderDetails.tamaPaymentTotal.toFixed(2)}
                            </span>
                          </div>

                          <div className="flex justify-between items-start gap-2">
                            <div className="flex items-center space-x-1 flex-1">
                              <span className="text-xs sm:text-sm text-gray-600">
                                Platform Fee{" "}
                                <Tooltip
                                  description="This helps us operate our platform and cover
                                  payment processing fees."
                                />
                              </span>
                            </div>
                            <span className="text-xs sm:text-sm text-gray-900 font-medium">
                              ${orderDetails.platformFeesForTama.toFixed(2)}
                            </span>
                          </div>

                          <div className="border-t border-emerald-100 space-y-6 sm:space-y-6 pt-1 sm:pt-4">
                            <div className="flex justify-between items-start gap-2">
                              <span className="text-xs sm:text-sm text-gray-900 font-medium flex-1">
                                Subtotal
                              </span>
                              <span className="text-xs sm:text-sm text-gray-900 font-medium">
                                ${orderDetails.subtotalWithFees.toFixed(2)}
                              </span>
                            </div>

                            <div className="flex justify-between items-start gap-2 py-2 text-emerald-600">
                              <span className="text-xs sm:text-sm flex-1">
                                Credit Applied
                              </span>
                              <span className="text-xs sm:text-sm font-medium">
                                -${orderDetails.creditApplied.toFixed(2)}
                              </span>
                            </div>

                            <div className="flex justify-between items-start gap-2 py-2 border-t border-emerald-100">
                              <span className="text-xs sm:text-sm font-bold text-gray-900 flex-1">
                                Final Charge
                              </span>
                              <span className="font-bold text-emerald-600 text-xs sm:text-sm">
                                ${orderDetails.finalTotalToPay.toFixed(2)}
                              </span>
                            </div>
                          </div>
                        </div>

                        <button
                          className="w-full bg-gradient-to-r from-green-500 to-green-800 hover:from-green-700 hover:to-green-500 text-white font-bold py-3 sm:py-4 px-4 sm:px-6 rounded-xl transition-all duration-200 transform hover:scale-[1.02] shadow-lg hover:shadow-xl mt-4 sm:mt-5 text-sm sm:text-base flex-shrink-0"
                          onClick={checkout}
                        >
                          Place Order
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  /* Empty Cart State */
                  <div className="flex justify-center items-center min-h-[400px]">
                    <div className="text-center bg-white rounded-2xl shadow-sm border border-emerald-100 p-12 max-w-md w-full">
                      <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
                        <svg
                          className="w-10 h-10 text-emerald-500"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                          />
                        </svg>
                      </div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-3">
                        Your Cart is Empty
                      </h3>
                      <p className="text-gray-600 mb-8">
                        Start adding influencers by clicking the button below
                      </p>
                      <button
                        className="w-full bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-200 transform hover:scale-[1.02]"
                        onClick={exploreInf}
                      >
                        Explore Influencers
                      </button>
                    </div>
                  </div>
                )}

                {/* Guide Steps */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
                  <div className="text-center p-4 bg-white border border-gray-200 rounded-xl hover:shadow-md transition-shadow duration-200">
                    <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-lg font-bold mx-auto mb-4">
                      1
                    </div>
                    <h4 className="font-bold text-gray-900 mb-2">
                      Place Offer
                    </h4>
                    <p className="text-gray-600 text-sm">
                      Submit collaboration details. Influencers have 72 hours to
                      accept, otherwise funds return to your TAMA balance.
                    </p>
                  </div>

                  <div className="text-center p-4 bg-white border border-gray-200 rounded-xl hover:shadow-md transition-shadow duration-200">
                    <div className="w-12 h-12 bg-green-100 text-green-600 rounded-full flex items-center justify-center text-lg font-bold mx-auto mb-4">
                      2
                    </div>
                    <h4 className="font-bold text-gray-900 mb-2">
                      Chat With Influencer
                    </h4>
                    <p className="text-gray-600 text-sm">
                      Coordinate collaboration details. Your funds are held
                      securely until work completion.
                    </p>
                  </div>

                  <div className="text-center p-4 bg-white border border-gray-200 rounded-xl hover:shadow-md transition-shadow duration-200">
                    <div className="w-12 h-12 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center text-lg font-bold mx-auto mb-4">
                      3
                    </div>
                    <h4 className="font-bold text-gray-900 mb-2">
                      Receive Content
                    </h4>
                    <p className="text-gray-600 text-sm">
                      Review and approve content. Payment is released to the
                      influencer upon completion.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
          {toastList && <Toast list={toastList} setList={setToastList} />}
        </>
      )}
      {isUserHasSubscription === false && user !== null && (
        <NotSubscribe
          goToPricing={goToPricing}
          type="brand"
          setAuth={setAuth}
          setModal={setModal}
          NotifModul={NotifModul}
          setNotifModul={setModalNotification}
          profiles={profiles}
          closeCartPanel={closeCartPanel}
          user={user}
          cartItem={cartItem}
          title={"Orders"}
          background={"background_orders.png"}
        />
      )}
    </>
  );
}
